import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { t } from "i18next";
import { forwardRef, useImperativeHandle, useState } from "react";
import { APP_ICONS } from "../../assets";
import GlobalButton from "../CustomButton";
import Label from "../Label";
import SelectInput from "../SelectInput";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width: "500px",
    padding: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
      margin: 12,
    },
  },
  "& .MuiDialogContent-root": {
    padding: "0 0",
    [theme.breakpoints.down("sm")]: {
      padding: "0 8px",
    },
  },
}));

const cities = [
  { label: "Wah cant", value: "Wah cant" },
  { label: "Rawalpindi", value: "Rawalpindi" },
  { label: "Islamabad", value: "Islamabad" },
];
const service = [
  { label: "Hair cut", value: "Hair cut" },
  { label: "Skin Polish", value: "Skin Polish" },
];
const status = [
  { label: "Accepted", value: "Accepted" },
  { label: "New", value: "New" },
  { label: "Completed", value: "Completed" },
];

let paramsData = {};

const ClientOwnerFilterDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);

  useImperativeHandle(ref, () => ({
    isVisible(params) {
      paramsData = params;
      setOpen(true);
    },
  }));

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <Stack direction={"row"} justifyContent={"space-between"}>
        <DialogTitle sx={{ m: 0, p: 0 }} id="customized-dialog-title">
          {t("filters")}
        </DialogTitle>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Label labelText={t("filterByCity")} />
            <SelectInput
              icon={
                <img
                  src={APP_ICONS.boundyBoxIcon}
                  alt={"city-icon"}
                  width={20}
                />
              }
              options={cities}
            />
          </Grid>
          <Grid item xs={12}>
            <Label labelText={t("filterByService")} />
            <SelectInput
              icon={
                <img
                  src={APP_ICONS.briefcaseIcon}
                  alt={"city-icon"}
                  width={20}
                />
              }
              options={service}
            />
          </Grid>
          <Grid item xs={12}>
            <Label labelText={t("filterByStatus")} />
            <SelectInput
              icon={
                <img
                  src={APP_ICONS.minimizeIcon}
                  alt={"city-icon"}
                  width={20}
                />
              }
              options={status}
            />
          </Grid>
        </Grid>
        <Typography
          my={1}
          variant="body2"
          display={"inline-block"}
          sx={{ cursor: "pointer" }}
        >
          {t("clearAllFilters")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"outlined"}
          btnText={"cancel"}
          styleProps={{ width: 100, height: 40 }}
          handleClickBtn={handleClose}
        />
        <GlobalButton
          variant={"contained"}
          btnText={"yes"}
          styleProps={{ width: 100, height: 40 }}
          handleClickBtn={handleClose}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default ClientOwnerFilterDialog;
